import React from 'react'
import styled from 'styled-components'

type IProps = {
    style: StyleSheet
    children: React.ReactNode
}

const RowToIndex = ({ style, children }: IProps) => {
    return <Row style={style}>{children}</Row>
}

export default RowToIndex

const Row = styled.div`
    display: flex;
    flex-direction: row;
    font-family: 'SourceSansPro-SemiBold', sans-serif;
`
